import ApplicationAdapter from './application';

export default class Media extends ApplicationAdapter {
  namespace = 'media/v4';
  modelNamePlural = 'media';
}
